import React from 'react';
// Custom linear progress bar that shows discrete segments

import { Box, Typography } from "@mui/material";

// Function to calculate color shade based on the segment index
const getSegmentColorShade = (index, segments, color) => {
  // Set a minimum opacity threshold to ensure visibility
  const minOpacity = 0.4;

  // Calculate opacity with a higher starting point
  // This ensures even the leftmost segments have enough color
  const baseOpacity = minOpacity + ((1 - minOpacity) * index) / (segments - 1);

  // For hex color transparency
  const opacityHex = Math.floor(baseOpacity * 255)
    .toString(16)
    .padStart(2, "0");

  // Return the color with proper opacity
  return `${color}${opacityHex}`;
};

const SegmentedProgressBar = ({ value, color, qna }) => {
  const segments = 10; // Total number of segments
  const filledSegments = Math.round((value / 100) * segments);
  return (
    <Box
      sx={{
        display: "flex",
        gap: 0.5,
        flex: 1,
        justifyContent: qna ? "space-between" : "flex-start",
      }}
    >
      <Box display="flex" gap={0.5}>
        {Array.from({ length: segments }).map((_, index) => (
          <Box
            key={index}
            sx={{
              width: 25,
              height: 25,
              borderRadius: 1,
              // bgcolor: index < filledSegments ? color : "#f0f0f0",
              bgcolor:
                index < filledSegments
                  ? getSegmentColorShade(index, segments, color) // Apply shade effect for filled segments
                  : "#f0f0f0", // Light gray for empty segments
            }}
          />
        ))}
      </Box>
      <Typography variant="body2" sx={{ fontWeight: 600, minWidth: 40 }}>
        {Number(value).toFixed(1)}%
      </Typography>
    </Box>
  );
};

export default SegmentedProgressBar;
